import React, { useState, useEffect } from 'react';
import uuid from 'uuid/v4';
import { Grid, Paper, Typography } from '@material-ui/core';
import PagamentoCard from './pagamentoCard';

import { useStyles } from './styles';
import { useStyles as useBaseStyles } from '../baseStyle';

function Pagamento(props) {
  const classes = useStyles(props);
  const classesStylesBase = useBaseStyles(props);

  const [serviceItem, setServiceItem] = useState([]);
  const [signatureItem, setSignatureItem] = useState([]);
  const [user, setUserData] = useState('');
  const [forms, setForms] = useState([]);

  const { signaturePlan } = props.location.state;

  useEffect(() => {
    const { item, signaturePlan } = props.location.state;

    setUserData(props.location.state.user);
    setServiceItem(item);
    setSignatureItem(signaturePlan);
    setForms(item.servico_forma_pagamento);
  }, [props.location.state]);

  return (
    <Grid
      container
      spacing={0}
      alignItems="center"
      justifyContent="center"
      className={classes.grid}
    >
      <Paper className={classesStylesBase.root}>
        <div className={classesStylesBase.logoContainer}>
          <img
            src="/logo-black.png"
            alt="Xmei Logo"
            className={classesStylesBase.logo}
          />
        </div>
        <Typography className={classes.header}>Formas de Pagamento</Typography>
        <div className={classes.container}>
          <div className={classes.viewAbsolute} />
          <div className={classes.viewCards}>
            {forms.map((form, index) => {
              return form.forma_de_pagamento.descricao !== 'BOLETO' ? (
                <PagamentoCard
                  key={uuid()}
                  title={form.forma_de_pagamento.descricao}
                  parcelas={form.forma_de_pagamento.parcelas}
                  valor={
                    serviceItem.valor + parseFloat(signatureItem.valor / 100)
                  }
                  item={serviceItem}
                  signaturePlan={signaturePlan}
                  user={user}
                />
              ) : (
                <></>
              );
            })}
          </div>
        </div>
      </Paper>
    </Grid>
  );
}

export default Pagamento;
